import categories from "./categories";
import products from "./products";

export default {
    categories,
    products
}
